import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DTCopyTextSendMacroView from 'components/DecisionTree/NodeGroups/DTCopyTextSendMacro/DTCopyTextSendMacroView';
import { handleError } from 'services/ErrorService/ErrorService';
import { replaceOrderItems } from 'actions/tools/CommonAsyncOrderActions';
import {
  getselectedConversationId,
  getSimplrAccountIdOfSelectedTicket,
  getAllMessages,
  getCustomerDetails,
} from 'extractFromState';
import { getSelectedProduct, selectSelectedToolDomains } from 'selectors/tools';
import { addNoteToSelectedTicket } from 'actions';
import { ISSUE_REPLACEMENT_TEXT } from './DTSendMacroAndReplaceItemFromProductSearchNodeConstants';

const DTSendMacroAndReplaceItemFromProductSearchNode = () => {
  const dispatch = useDispatch();
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const conversationId = useSelector(getselectedConversationId);
  const customerDetails = useSelector(getCustomerDetails);
  const selectedProduct = useSelector(getSelectedProduct);
  const allMessages = useSelector(getAllMessages);
  const toolDomains = useSelector(selectSelectedToolDomains);
  const domain = toolDomains.shopify[0];
  const [isItemReplacementIssued, setIsItemReplacementIssued] = useState(false);

  const createItemReplacementNote = () => {
    const productId = selectedProduct.id ?? selectedProduct.sku;
    const replacementNote = `${ISSUE_REPLACEMENT_TEXT} ${selectedProduct.title} (${productId}).`;

    return replacementNote;
  };

  const handleNextButtonClick = async () => {
    try {
      setIsItemReplacementIssued(true);
      await dispatch(
        replaceOrderItems({
          simplrAccountId,
          conversationId,
          domain,
          customerEmail: customerDetails.email,
          shippingAddress: {
            firstName: customerDetails.firstName,
            lastName: customerDetails.lastName,
            address1: customerDetails.addressLineOne,
            address2: customerDetails.addressLineTwo,
            phone: customerDetails.phoneNumber,
            city: customerDetails.city,
            state: customerDetails.state,
            country: customerDetails.country,
            zip: customerDetails.zipCode,
          },
          items: [{ itemId: selectedProduct.id, itemQuantity: 1 }],
          chargeShipping: false,
        })
      );
      dispatch(addNoteToSelectedTicket(createItemReplacementNote()));
    } catch (error) {
      handleError({
        error,
        customMessage: 'Something went wrong while using the item replacement. Please try again later.',
        showPopup: true,
      });
      setIsItemReplacementIssued(false);
    }
  };

  useEffect(() => {
    /**
     *  Check for an already replaced item internal note to avoid
     *  possibility of issuing another replacement when it was
     *  already issued and successful.
     */
    const internalNotes = allMessages.filter(
      (message) => message.direction === 'INTERNAL' && message.noteType === 'HINT'
    );
    setIsItemReplacementIssued(internalNotes.some((message) => message.messagePlain.includes(ISSUE_REPLACEMENT_TEXT)));
  }, [allMessages]);

  return (
    <DTCopyTextSendMacroView
      buttonText={'REPLACE ITEM'}
      onNextButtonClick={handleNextButtonClick}
      popupConfirmationText={
        'You are about to issue a replacement item to the customer with the details above and copy the response to the text box'
      }
      customErrorMessage={'Error issuing the item replacement. Please try again later.'}
      disableActionButton={isItemReplacementIssued}
    ></DTCopyTextSendMacroView>
  );
};

export default DTSendMacroAndReplaceItemFromProductSearchNode;
